"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Video = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var styled_components_1 = __importDefault(require("styled-components"));
var lazy_1 = __importDefault(require("react-player/lazy"));
var react_intersection_observer_1 = require("react-intersection-observer");
var styles_1 = require("../../styles");
var styles_2 = require("../../styles");
var hooks_1 = require("../../hooks");
var Figure = styled_components_1.default.figure(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  height: auto;\n  position: relative;\n  width: 100%;\n\n  img {\n    width: 100%;\n  }\n\n  figcaption {\n    ", "\n    border-bottom: ", ";\n    padding-bottom: ", ";\n    margin-bottom: ", ";\n\n    ", "\n  }\n\n  > div {\n    height: 100%!important;\n    width: 100%!important;\n  }\n"], ["\n  height: auto;\n  position: relative;\n  width: 100%;\n\n  img {\n    width: 100%;\n  }\n\n  figcaption {\n    ", "\n    border-bottom: ", ";\n    padding-bottom: ", ";\n    margin-bottom: ", ";\n\n    ", "\n  }\n\n  > div {\n    height: 100%!important;\n    width: 100%!important;\n  }\n"])), (0, styles_2.getP12)(), function (_a) {
    var theme = _a.theme;
    return (0, styles_2.hex2Rgba)(theme.colors.black, .1);
}, (0, styles_1.getRelative)(20, 'mobile'), (0, styles_1.getRelative)(20, 'mobile'), styles_1.mq.greaterThan('tablet')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      padding-bottom: ", ";\n      margin-bottom: ", ";\n    "], ["\n      padding-bottom: ", ";\n      margin-bottom: ", ";\n    "])), (0, styles_1.getRelative)(20, 'desktop'), (0, styles_1.getRelative)(20, 'desktop')));
exports.Video = (0, react_1.memo)(function (_a) {
    var data = _a.data, _b = _a.longModal, longModal = _b === void 0 ? false : _b, _c = _a.modalActive, modalActive = _c === void 0 ? false : _c, _d = _a.playsinline, playsinline = _d === void 0 ? false : _d;
    var platform = data.platform, longVideo = data.long_video, shortVideo = data.short_video;
    var _e = __read((0, react_1.useState)(!longModal), 2), playing = _e[0], setPlaying = _e[1];
    var _f = __read((0, react_intersection_observer_1.useInView)({
        rootMargin: '0px',
        threshold: 0,
    }), 2), ref = _f[0], inView = _f[1];
    var mediaType = (0, hooks_1.useMediaType)();
    var url = "https://www.".concat(platform, ".com/").concat(platform === 'youtube' ? 'watch?v=' : '').concat(longModal ? longVideo : shortVideo);
    (0, react_1.useEffect)(function () {
        if (longModal)
            return;
        setPlaying(inView);
    }, [inView]);
    (0, react_1.useEffect)(function () {
        if (longModal)
            setPlaying(modalActive);
    }, [modalActive]);
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)(Figure, __assign({ ref: ref, longModal: longModal, className: 'figure--video' }, { children: (0, jsx_runtime_1.jsx)(lazy_1.default, { url: url, playsinline: mediaType === 'mobile' ? true : playsinline, controls: longModal, volume: 0, muted: !longModal, loop: mediaType === 'mobile' ? true : !longModal, title: '', playing: mediaType === 'mobile' ? true : playing }) })) }));
});
var templateObject_1, templateObject_2;
